import { HomePageLoganType, logan } from './Logan';

const Metrics = Mach.requireModule('Metrics');
const SLMetrics = Mach?.requireModule?.('SLMetrics');

export enum MStepType {
  Start = 'start',
  End = 'end',
  None = 'none'
}

export class HomePageMetrics {
  private identifiers: string[];
  private initTime: number;
  private steps: { step: string; time: number; }[] = [];
  private stepKeys: string[] = [];
  private releaseTag: boolean = false;
  private isReportAll: boolean = false;

  constructor(identifiers: string[], initTime: number = Date.now()) {
    this.identifiers = identifiers;
    this.initTime = initTime;
  }

  recordStep(stepName: string, type: MStepType = MStepType.None, curTs: number = Date.now()): void {
    if (this.releaseTag) {
      return;
    }

    const stepTag = type === MStepType.None ? stepName : `${stepName}->${type}`;
    if (this.stepKeys.includes(stepTag)) {
      return;
    }
    this.stepKeys.push(stepTag);

    const step = {
      step: stepTag,
      time: curTs - this.initTime
    };
    this.steps.push(step);

    SLMetrics?.recordHomeKeyNode?.(stepTag);

    if (stepTag === 'marketReload->end') {
      SLMetrics?.recordHomeC1?.();
      // console.log('marketReload->endmarketReload->endmarketReload->end');
    }
  }

  release(): void {
    this.releaseTag = true;
    this.steps = [];
    this.stepKeys = [];
  }

  report(): void {
    if (Metrics && this.identifiers && this.steps && Metrics?.reportSteps && !this.releaseTag) {
      this.identifiers.forEach((identifier) => {
        Metrics.reportSteps(identifier, [...this.steps]);

        // 首页全链路测速steps logan
        if (identifier === 'SAILOR_HOME_PAGE_METRICS_CUSTOM_STEP_ALL' && this.isReportAll === false) {
          this.isReportAll = true;
          logan(HomePageLoganType.Main, { msg: '首页首屏渲染结束', steps: [...this.steps] });
          SLMetrics?.recordHomeC2?.();
        //   console.log('🐑🐑🐑🐑🐑 HomePageMetrics log ', identifier, this.steps);
        }
      });
      this.release();
    }
  }

  recordSteps(identifier: string, steps: []): void {
    Metrics?.record?.(identifier, steps);
    if (Mach.env.isDebug) {
      console.log('🐑🐑🐑🐑🐑 HomePageMetrics log ', identifier, steps);
    }
  }
}
